import { render, staticRenderFns } from "./questions-edit.vue?vue&type=template&id=01941963&"
import script from "./questions-edit.vue?vue&type=script&lang=js&"
export * from "./questions-edit.vue?vue&type=script&lang=js&"
import style0 from "./questions-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01941963')) {
      api.createRecord('01941963', component.options)
    } else {
      api.reload('01941963', component.options)
    }
    module.hot.accept("./questions-edit.vue?vue&type=template&id=01941963&", function () {
      api.rerender('01941963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/medical-manage/health-manage/questions-edit.vue"
export default component.exports